module.exports = __webpack_public_path__ + "static/media/LCScriptWeb-Regular.8715baf1.woff2";